// removed by extract-text-webpack-plugin
module.exports = {"ModalWrap":"_3BgCqi7O5n8osLQq_IKAUL","Size500":"_1jrOn1YHxjHWNSINXhAjaO","Content":"_3udjx9U3Qgb0megzz4vSR","Header":"_1gArubBRaYm-dnjWzoWmRZ","Close":"_27r_0F3aOhbEjh8xevFimh","Body":"_3OAnhrxAuJ3eiS-wZrKF1H","Title":"_1AnKrxjBihWvkWGmJJlxtk","Footer":"qGjF5j0oeynTQHrwBOUWb","ConfirmBtn":"jQTqcfVge3vgfT0ondNCz","CancelBtn":"_2QZT0sgg2kijExlUPfNTTd"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Utils/Modal/styles.module.css
// module id = 592
// module chunks = 0